import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RELATIVE_URL} from '../crud-config';
import { API_PATH } from 'src/environments/environment';
import { AbstractCrudService } from 'src/app/shared/components/crud/abstract-crud.service';

@Injectable({
  providedIn: 'root',
})
export class FormEventService extends AbstractCrudService {
    constructor(protected override httpClient: HttpClient) {
      super(httpClient, RELATIVE_URL);
    }
  
    saveFormResponses(responses: any): Observable<any> {
      return this.httpClient.post(`${API_PATH}form-responses`, responses);
    }
  
    getResponsesByFormId(id: string): Observable<any[]> {
      return this.httpClient.get<any[]>(`${API_PATH}form-responses/${id}`);
    }
}
